import { MenuItem, Select } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'left',
    height: '100%'
  },
  input: {
    flexGrow: 1,
    height: '42px',
    backgroundColor: 'transparent',
    width: '100%',
    '& .MuiSelect-select': {
      display: 'block',
      lineHeight: '42px',
      height: '100%',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: '14px',
      paddingRight: '32px',
      fontSize: '14px',
      color: '#334155',
      fontWeight: '500',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none'
    }
  },
  inputElements: {
    display: 'flex',
    width: '100%',
    height: '100%'
  },
  menuItem: {
    fontSize: '14px',
    color: '#334155',
    fontWeight: '500',
    '&.Mui-selected': {
      color: '#4f46e5',
      backgroundColor: '#eef2ff'
    },
    '&.Mui-selected:hover': {
      backgroundColor: '#e0e7ff'
    }
  }
}));

export default function MultiplePicker({
  items,
  selectedItems,
  setSelectedItems,
  getTitle,
  getValue,
  defaultOptionLabel
}) {
  const classes = useStyles();
  const value = selectedItems.length === 0 ? [null] : selectedItems;

  const handleChange = event => {
    const values = event.target.value;
    const validValues = values.filter(Boolean);

    if (!values.length) setSelectedItems([]);

    values.forEach(value =>
      value === null ? setSelectedItems([]) : setSelectedItems(validValues)
    );
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.inputElements}>
        <Select
          multiple
          className={classes.input}
          value={value}
          onChange={handleChange}
          variant="outlined"
          renderValue={(selected) => {
            const selectedList = Array.isArray(selected) ? selected : [selected];
            const activeItems = selectedList.filter(val => val !== null && val !== undefined);
            if (activeItems.length === 0) {
              return defaultOptionLabel;
            }
            
            const titles = activeItems.map(val => {
              const matchedItem = items?.find(item => {
                const itemVal = getValue ? getValue(item) : item._id;
                return itemVal === val;
              });
              if (matchedItem) {
                return getTitle ? getTitle(matchedItem) : (matchedItem.displayName || matchedItem.title);
              }
              return val;
            });
            
            return titles.join(', ');
          }}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left'
            },
            getContentAnchorEl: null,
            PaperProps: {
              style: {
                borderRadius: '12px',
                marginTop: '8px',
                boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)'
              }
            }
          }}>
          <MenuItem value={null}>{defaultOptionLabel}</MenuItem>
          {items?.map((item, i) => (
            <MenuItem
              className={classes.menuItem}
              value={getValue ? getValue(item) : item._id}
              key={i}>
              {getTitle ? getTitle(item) : item.displayName || item.title}
            </MenuItem>
          ))}
        </Select>
      </div>
    </div>
  );
}
